import { CUSTOMERS_MANAGE } from 'constants/permissions'
import { ReactLazyPreload } from 'utilities/PreloadLinks'

const EmailsHome = ReactLazyPreload(() =>
  import('../components/Emails/EmailsHome').then((file) => {
    return { default: file.EmailsHome }
  })
)

const CampaignsList = ReactLazyPreload(() =>
  import('../components/Emails/components/CampaignsList').then((file) => {
    return { default: file.CampaignsList }
  })
)

const EmailLists = ReactLazyPreload(() =>
  import('../components/Emails/components/EmailLists').then((file) => {
    return { default: file.EmailLists }
  })
)

export const EmailsDirectoryRoute = () => {
  return [
    {
      path: '/emails',
      name: 'Emails',
      component: EmailsHome,
      exact: true,
    },
  ]
}

export const useRoutes = () => {
  return [
    {
      path: '/emails/campaigns',
      name: 'Campaigns',
      component: CampaignsList,
      exact: true,
      permissions: [CUSTOMERS_MANAGE],
    },
    {
      path: '/emails/lists',
      name: 'Email lists',
      component: EmailLists,
      exact: true,
      permissions: [CUSTOMERS_MANAGE],
    },
  ]
}
